import React, { Component } from "react";


class ClassFilters extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		isOpenDuration: false,
		isOpenInstructors: false,
		isOpenSubCategories: false,
		isOpenMusic: false
    }
	
}
 
componentDidMount(){
	
}

openCloseDuration=()=>{
	var isOpenDurationVar = this.state.isOpenDuration;
	isOpenDurationVar = !isOpenDurationVar;
	this.setState({isOpenDuration: isOpenDurationVar});
}

openCloseInstructors=()=>{
	var isOpenInstructorsVar = this.state.isOpenInstructors;
	isOpenInstructorsVar = !isOpenInstructorsVar;
	this.setState({isOpenInstructors: isOpenInstructorsVar});
}

openCloseSubCategories=()=>{
	var isOpenSubCategoryVar = this.state.isOpenSubCategories;
	isOpenSubCategoryVar = !isOpenSubCategoryVar;
	this.setState({isOpenSubCategories: isOpenSubCategoryVar});
}

openCloseMusic=()=>{
	var isOpenMusicVar = this.state.isOpenMusic;
	isOpenMusicVar = !isOpenMusicVar;
	this.setState({isOpenMusic: isOpenMusicVar});
}

  render() {
	 return (
		<div className="filters_content">
			<div className="filters_title">Filters
				{ ( this.props.chosenDurationFilter.length > 0 || this.props.chosenSubCategoryFilter.length > 0 || this.props.chosenMusicData.length > 0 || this.props.chosenInstructrosFilter.length > 0 || this.props.advancedClassFilter || this.props.attendedClassFilter ) &&
					<div className="reset_filter" onClick={this.props.resetFilter}>RESET</div>
				}
			</div>
			{ this.props.subCategoryFilter && this.props.subCategoryFilter.length > 0 &&
				<div className="one_filter_content">
					<div className="filter_title" onClick={this.openCloseSubCategories}>Sub-Categories
						<div className="filter_icon subCategoryIcon"></div>
						<div className={"arrow_filter " + ( this.state.isOpenSubCategories ? "active_arrow" : "" )}></div>
					</div>
					{ this.state.isOpenSubCategories ?
						<div className="filter_content">
							{ this.props.subCategoryFilter.map((item, i) =>
								<div className={"one_filter one_filter_subcategory " + ( this.props.chosenSubCategoryFilter.indexOf(item.id) > -1 ? "active" : "" )} key={i} onClick={() => this.props.setFilter('subcategory', item)}>{item.name}</div>
							)}
						</div>
						:
						<div>
							{ this.props.chosenSubCategoryDataFilter.length > 0 &&
								<div className="durFilterOut">
									{ this.props.chosenSubCategoryDataFilter.map((item, i) =>
										<div className={"chosenDurFilter mrgbot8 " + (i > 0 ? "mrgLft8" : "")} key={i}>{item}</div>
									)}
								</div>
							}
						</div>
					}
				</div>
			}
			<div className="one_filter_content">
				<div className="filter_title" onClick={this.openCloseDuration}>Duration (minutes)
					<div className="filter_icon duration_icon"></div>
					<div className={"arrow_filter " + ( this.state.isOpenDuration ? "active_arrow" : "" )}></div>
				</div>
				{ this.state.isOpenDuration ?
					<div className="filter_content">
						{ this.props.durationsFilter.map((item, i) =>
							<div className={"one_filter one_filter_duration " + ( this.props.chosenDurationFilter.indexOf(item) > -1 ? "active" : "" )} key={i} onClick={() => this.props.setFilter('duration', item)}>{item}</div>
						)}
					</div>
					:
					<div>
						{ this.props.chosenDurationFilter.length > 0 &&
							<div className="durFilterOut">
								{ this.props.chosenDurationFilter.map((item, i) =>
									<div className={"chosenDurFilter " + (i > 0 ? "mrgLft8" : "")} key={i}>{item}</div>
								)}
							</div>
						}
					</div>
				}
			</div>
			{ this.props.musicFilters.length > 0 &&
				<div className="one_filter_content">
					<div className="filter_title" onClick={this.openCloseMusic}>Music
						<div className="filter_icon music_filter"></div>
						<div className={"arrow_filter " + ( this.state.isOpenMusic ? "active_arrow" : "" )}></div>
					</div>
					{ this.state.isOpenMusic ?
						<div className="filter_content">
							{ this.props.musicFilters.map((item, i) =>
								<div className={"one_filter one_filter_instructors " + ( this.props.chosenMusicFilters.indexOf(item.musicType) > -1 ? "active" : "" )} key={i} onClick={() => this.props.setFilter('music', item)}>{item.musicType}</div>
							)}
						</div>
						:
						<div>
							{ this.props.chosenMusicData.length > 0 &&
								<div className="durFilterOut">
									<div className="chosenDurFilter">{this.props.chosenMusicData[0]['musicType']}</div>
										{ this.props.chosenMusicData.length > 1 &&
											<div className="chosenDurFilter mrgLft8">+{this.props.chosenMusicData.length-1} Others</div>
										}
								</div>
							}
						</div>
					}
				</div>
			}
			{ this.props.instructorsFilter.length > 0 &&
				<div className="one_filter_content">
					<div className="filter_title" onClick={this.openCloseInstructors}>Instructor
						<div className="filter_icon instructor_icon"></div>
						<div className={"arrow_filter " + ( this.state.isOpenInstructors ? "active_arrow" : "" )}></div>
					</div>
					{ this.state.isOpenInstructors ?
						<div className="filter_content">
							{ this.props.instructorsFilter.map((item, i) =>
								<div className={"one_filter one_filter_instructors " + ( this.props.chosenInstructrosFilter.indexOf(item.id) > -1 ? "active" : "" )} key={i} onClick={() => this.props.setFilter('instructor', item)}>{item.firstName} {item.lastName}</div>
							)}
						</div>
						:
						<div>
							{ this.props.chosenInstructrosDataFilter.length > 0 &&
								<div className="durFilterOut">
									<div className="chosenDurFilter">{this.props.chosenInstructrosDataFilter[0]['fullName']}</div>
										{ this.props.chosenInstructrosDataFilter.length > 1 &&
											<div className="chosenDurFilter mrgLft8">+{this.props.chosenInstructrosDataFilter.length-1} Others</div>
										}
								</div>
							}
						</div>
					}
				</div>
			}
			<div className="one_filter_content">
				<div className="filter_title toggle_title">Advanced Classes
					<div className="switch_check" onClick={() => this.props.updateStateFromChild({'advancedClassFilter': !this.props.advancedClassFilter})}>
						<input type="checkbox" checked={this.props.advancedClassFilter} />
						<span className="slider_filter round_filter"></span>
					</div>
				</div>
			</div>
			<div className="one_filter_content">
				<div className="filter_title toggle_title">Show Attended Classes
					<div className="switch_check" onClick={() => this.props.updateStateFromChild({'attendedClassFilter': !this.props.attendedClassFilter})}>
						<input type="checkbox" checked={this.props.attendedClassFilter} />
						<span className="slider_filter round_filter"></span>
					</div>
				</div>
			</div>
			<div className="apply_btn" onClick={this.props.applyFilters}>Apply Filters</div>
		</div>
    );
  }
}
export default ClassFilters;
